// Definimos la URL base según la variable de entorno, con fallback a localhost
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchEdificios = async ({ limit, offset, query, userId, userRole }) => {
  try {
    const response = await fetch(`${API_URL}/edificios/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        limit, 
        offset, 
        query,
        userId,
        userRole
      }),
    });

    if (!response.ok) {
      throw new Error('Error al obtener los edificios');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener los edificios:', error);
    throw error;
  }
};

export const createEdificio = async (edificioData) => {
  try {
    const response = await fetch(`${API_URL}/edificios/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(edificioData),
    });

    if (!response.ok) {
      throw new Error('Error al crear el edificio');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al crear el edificio:', error);
    throw error;
  }
};

export const updateEdificio = async (id, edificioData) => {
  try {
    const response = await fetch(`${API_URL}/edificios/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, data: edificioData }),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar el edificio');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al actualizar el edificio:', error);
    throw error;
  }
};

export const deleteEdificio = async (id) => {
  try {
    const response = await fetch(`${API_URL}/edificios/delete/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('Error al eliminar el edificio');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al eliminar el edificio:', error);
    throw error;
  }
};

export const exportEdificios = async ({ query = {}, limit = 10000, page = 1 }) => {
  try {
    const response = await fetch(`${API_URL}/edificios/export`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    });

    if (!response.ok) {
      throw new Error('Error al exportar los edificios');
    }

    const result = await response.json();
    
    // El backend devuelve JSON con estructura { data: [], totalRecords: number }
    // Retornamos los datos para que ExportExcelButton los procese
    return result.data || [];
  } catch (error) {
    console.error('Error al exportar los edificios:', error);
    throw error;
  }
};
